<article class="block-team container section-outset-y" (fstrInViewport)="initSwiper()" [once]="true">
  <div class="row block-team__row">
    <header class="col-md-6 d-flex order-2 flex-column justify-content-center">
      <div class="mb-md-4">
        <h2 *ngIf="block.title" class="block-team__title fs-display-1 fw-bold mb-4">
          <ngx-dynamic-hooks
            [options]="{ sanitize: false, updateOnPushOnly: true }"
            [content]="block.title | highlight : 'text-primary-gradient'"
            data-split
            [duration]="400"
            [context]="{ delayAnimation: 800, startShapeAnimation: inviewPort }"
            class="splitting splitting--word-in"
          ></ngx-dynamic-hooks>
        </h2>
        <h3 class="font-display h4 fw-bold block-team__subtitle" *ngIf="block.subtitle">{{ block.subtitle }}</h3>
      </div>
      <div class="h6 mb-0 mb-md-5 mt-lg-3 block-team__intro simple-markdown" *ngIf="block.text" [innerHTML]="block.text"></div>

      <fstr-link
        [cssClasses]="'d-none d-md-inline-flex button button button--primary-gradient has--dot block-team__button'"
        [button]="block.button"
        *ngIf="block.button"
      ></fstr-link>
    </header>

    <div class="col-md-6 order-1" *ngIf="block.teams">
      <div class="pull-s block-team__slider">
        @defer {
        <swiper-container init="false" #swiper>
          <swiper-slide *ngFor="let item of block.teams; let i = index; trackBy: trackByFn">
            <app-team-card [title]="item.firstName" [active]="i === swiperIndex$()" [image]="item.image" *ngIf="item.image"></app-team-card>
          </swiper-slide>
        </swiper-container>
        }
        <button (click)="slideNext()" class="block-team__slider__next button button button-icon button--dark" aria-label="Volgende">
          <fstr-icon anchor="icon-arrow-right"></fstr-icon>
        </button>
        <figure class="block-team__figure">
          <span
            class="font-display block-team__figure__title"
            *ngFor="let item of block.teams; let i = index; trackBy: trackByFn"
            [class.set--active]="inviewPort && i === swiperIndex$()"
          >
            <span class="text-light block-team__figure__title__rotate">{{ item.firstName }}</span>
          </span>
          <!-- <app-team-title-card [title]="item.name" [active]="blockInview && i === swiperIndex$()"></app-team-title-card> -->

          <app-text-shape
            *ngIf="inviewPort"
            [cssClasses]="'squiggle'"
            [type]="'standalone'"
            [autoplay]="true"
            shapeColor="secondary"
            shape="squiggle-07"
          ></app-text-shape>
        </figure>
      </div>

      <footer class="d-flex mt-4 justify-content-center align-items-center d-md-none">
        <fstr-link
          [cssClasses]="' button button button--primary-gradient has--dot block-team__button'"
          [button]="block.button"
          *ngIf="block.button"
        ></fstr-link>
      </footer>
    </div>
  </div>
</article>
